import { z } from 'zod';
import { ProsemirrorOutput } from 'libs/end-to-end/src/prosemirror';

export const DashboardAISummaryStatusList = [
  'pending',
  'generating-report',
  'generating-summary',
  'failed-generating-report',
  'failed-generating-summary',
  'success',
] as const;

export const DashboardAISummaryStatus = z.enum(DashboardAISummaryStatusList);

export type DashboardAISummaryStatus = z.infer<typeof DashboardAISummaryStatus>;

export const DashboardAISummaryLoadingStatus =
  DashboardAISummaryStatus.extract([
    'pending',
    'generating-report',
    'generating-summary',
  ]);

export type DashboardAISummaryLoadingStatus = z.infer<
  typeof DashboardAISummaryLoadingStatus
>;

export const DashboardAISummaryFailureStatus =
  DashboardAISummaryStatus.extract([
    'failed-generating-report',
    'failed-generating-summary',
  ]);

export type DashboardAISummaryFailureStatus = z.infer<
  typeof DashboardAISummaryFailureStatus
>;

export const DashboardAISummaryResultSuccess = z.object({
  resultType: z.literal('success'),
  summary: ProsemirrorOutput,
});

export type DashboardAISummaryResultSuccess = z.infer<
  typeof DashboardAISummaryResultSuccess
>;

export const DashboardAISummaryResultFailed = z.object({
  resultType: z.literal('failed'),
  error: z.string(),
});

export type DashboardAISummaryResultFailed = z.infer<
  typeof DashboardAISummaryResultFailed
>;

export const DashboardAISummaryDto = z.object({
  dashboardAISummaryId: z.string(),
  dashboardId: z.string(),
  createdAtEpoch: z.number(),
  status: DashboardAISummaryStatus,
  summary: ProsemirrorOutput.optional(),
});

export type DashboardAISummaryDto = z.infer<typeof DashboardAISummaryDto>;
